module.exports = __webpack_public_path__ + "media/images/workshop-38f407e4061d4329041aad1ecfeddd0a.png";